export const ajaxCall = (action, data = {}, method = "POST") => {
  const formData = new FormData();

  formData.append("action", action);
  formData.append("nonce", window.sby_settings.nonce);

  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value);
  });

  return fetch(window.sby_settings.ajax_handler, {
    method,
    body: formData,
  });
};
